export default __webpack_public_path__ + "static/prescriber3-004e778216e4d16ef6644fe5dc6a99f7.webp";